export default "__VITE_ASSET__jO8gLR0X__"